module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.notification.isShow) ? _c('div', {
    class: ['elevation-5', _vm.$root.isRTL ? 'notificationRTL' : 'notification'],
    on: {
      "click": function($event) {
        _vm.selectActivity(_vm.$root.notification.activityId)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-icon', [_vm._v("email")])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 5px 10px 0px"
    },
    attrs: {
      "xs9": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "musketeerFont",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$root.notification.info) + " by " + _vm._s(_vm.$root.notification.from))])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "musketeerFont"
  }, [_vm._v("Event: " + _vm._s(_vm.$root.notification.event))])])], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e153452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 898
// module chunks = 2